<div class="absolute langClass"> 
  <select class="lang-select bg-blue-200 z-20 rounded-lg selectClass" #langSelect (change)="changeLang(langSelect.value)">
      <option [value]="'ru'" [selected]="translate.currentLang == 'ru'">ru</option>
      <option [value]="'kz'" [selected]="translate.currentLang == 'kz'">kz</option>
  </select>
</div>
<simple-notifications></simple-notifications>
<router-outlet></router-outlet>